import { HttpClient, HttpHeaders,HttpEvent,HttpInterceptor,HttpRequest,HttpHandler} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/internal/operators/map';
import { environment } from 'src/environments/environment';
import { ToasterService } from './toaster.service';
import { catchError, of } from 'rxjs';
import { BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public content = new BehaviorSubject<any>(this.isLoggedIn);    
  public share = this.content.asObservable(); 


  constructor(private http: HttpClient, public router: Router, private toaster: ToasterService) { }

  signIn(login: any) {
    return this.http
      .post<any>(`${environment.host}/${environment.login}`, login)
      .subscribe((res: any) => {
        localStorage.setItem('access_token', res.token);
          this.router.navigate(['/services']);
          this.content.next(true);
      });
  }

  changePassword (changePassword: any) {
  this.http.post<any>(`${environment.host}/${environment.self}/${environment.password}`, changePassword)
        .pipe(catchError((error: any, caught: Observable<any>): Observable<any> => {
          this.toaster.openSnackBar(error.error, 'ok')
            // after handling error, return a new observable 
            // that doesn't emit any values and completes
            return of();
        }))
        .subscribe(res => {
          this.toaster.openSnackBar('Your password has been changed', 'ok')
          this.router.navigate(['/services']);
       });
      }

  getToken() {
    return localStorage.getItem('access_token');
  }

  get isLoggedIn(): boolean {
    let authToken = localStorage.getItem('access_token');
    return authToken !== null ? true : false;
  }

  doLogout() {
    let removeToken = localStorage.removeItem('access_token');
    if (removeToken == null) {
      this.router.navigate(['/login']);
      this.content.next(false);
    }
  }

  getUserInfo(): Observable<any> {
    let api = `${environment.host}/${environment.self}`;
    return this.http.get(api).pipe(
      map((res) => {
        return res || {};
      }) );
  }
  
}


